module.exports = {
          srcSet: __webpack_public_path__ + "images/2007-2-e4c0245b57b1cfbd819e58400895e797-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2007-2-768c8c0d0ff00e6eaf24a92119b35551-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2007-2-e4c0245b57b1cfbd819e58400895e797-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2007-2-768c8c0d0ff00e6eaf24a92119b35551-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2007-2-e4c0245b57b1cfbd819e58400895e797-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2007-2-e4c0245b57b1cfbd819e58400895e797-320.jpg"},
          
          width: 320,
          height: 251
        }